import { render, staticRenderFns } from "./Distributor.vue?vue&type=template&id=6c27b605&"
import script from "./Distributor.vue?vue&type=script&lang=js&"
export * from "./Distributor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports